import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Button, ButtonColor, ButtonSize } from '@videoblocks/storywind';
const PlanCtaButton = ({ planCta, logger, mobile = false }) => {
    return (<Button id={planCta.id} color={ButtonColor.Primary} size={ButtonSize.Small} className={twMerge('mainNav-cta lg:inline-block px-5 py-2 m-0 whitespace-nowrap font-inter font-semibold', mobile ? '' : 'hidden')} onClick={() => logger('conversion.ump.' + planCta.id)} href={planCta.url}>
      {mobile ? planCta.mobileLinkText : planCta.linkText}
    </Button>);
};
export default PlanCtaButton;
